import { jsx } from '@emotion/core';
import uniqueId from 'lodash/uniqueId';
import { Context } from './context';
var styles = {
  display: 'grid',
  gridGap: 8
};
export var RadioGroup = function RadioGroup(_a) {
  var _b = _a.children,
      children = _b === void 0 ? null : _b,
      selected = _a.selected,
      _c = _a.onChange,
      onChange = _c === void 0 ? function () {} : _c,
      name = _a.name;
  var groupName = uniqueId(name === undefined ? 'radiogroup' : name);
  return jsx(Context.Provider, {
    value: {
      selectedValue: selected,
      onChange: onChange,
      name: groupName
    }
  }, jsx("div", {
    css: styles,
    role: "radiogroup"
  }, children));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Radio/radioGroup.js
// module id = 1186
// module chunks = 0